import z from "zod";
import { MaintenanceForwardingsRequiredDirectiveStepsData } from "../types/maintenanceForwardingsShowDirectiveDetails.type";
import { directiveEntryFormSteps } from "../constants/directiveEntryFormSteps.constant";

export const buildDynamicSchema = (requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData) => {
  const keys = Object.keys(requiredDirectiveSteps) as Array<keyof typeof directiveEntryFormSteps>;

  let dynamicShape = z.object({});

  keys.forEach((key) => {
    const schemaForStep = directiveEntryFormSteps[key]?.schema;

    if (schemaForStep) {
      dynamicShape = dynamicShape.merge(schemaForStep);
    }
  });

  return dynamicShape;
}
